import React, { useEffect } from "react";

import { useFormikContext } from "formik";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";

import { Divider, Flex, Grid, GridItem, Text } from "@chakra-ui/react";

import { Group } from "../../Group";
import { CustomInputWField } from "../../../../../components/CustomInputWField";
import CustomDropzone from "../../../../../components/CustomDropzone";
import { RadioOptions } from "../../RadioOptions";
import { CustomDatepickerWField } from "../../../../../components/CustomDatepickerWField";

export const PossuiIdentidade = ({
  props,
  dataMenor,
  dataFutura,
  dataNascimento,
  scrollToField,
  idAnexo,
}) => {
  const { setFieldValue, values, errors, touched } = useFormikContext();

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  return (
    <Group
      border={idAnexo === "3" ? "3px solid #4299E199" : ""}
      scrollToField={idAnexo === "3" ? scrollToField : null}
    >
      <Text
        mt="5"
        mb="2"
        fontWeight={700}
        fontSize="16px"
        lineHeight="21.6px"
        color="#169499"
      >
        IDENTIDADE
      </Text>
      <Divider mb="5" />
      <RadioOptions
        label="Possui Identidade?*"
        fieldName="possuiIdentidade"
        errors={errors}
        touched={touched}
      />
      {values.possuiIdentidade === "S" && (
        <>
          <Grid
            mt="15px"
            templateColumns="repeat(5, 1fr)"
            gap="25px"
            rowGap="20px"
          >
            <GridItem colSpan={{ base: 3, sm: 3, lg: 2 }}>
              <CustomInputWField
                whiteSpace={true}
                fieldName="numeroIdentidade"
                label="Número da Identidade*"
                placeholder="Informe o Número da Identidade"
              />
            </GridItem>
            <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
              <CustomInputWField
                whiteSpace={true}
                fieldName="orgaoExpedidor"
                label="Órgão Expedidor"
                placeholder="Informe o Órgão Expedidor"
              />
            </GridItem>
            <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
              <CustomDatepickerWField
                fieldName="dataExpedicaoIdentidade"
                label="Data da Expedição"
                placeholder="DD/MM/AAAA"
                maxDate={new Date()}
              />
              {dataMenor &&
                dataNascimento &&
                props.values.dataExpedicaoIdentidade && (
                  <Text
                    mt="8px"
                    color="#E53E3E"
                    fontSize="sm"
                    lineHeight={"normal"}
                  >
                    Data de expedição menor que a data de nascimento.
                  </Text>
                )}

              {dataFutura && props.values.dataExpedicaoIdentidade && (
                <Text
                  mt="8px"
                  color="#E53E3E"
                  fontSize="sm"
                  lineHeight={"normal"}
                >
                  A data informada não pode ser uma data futura!
                </Text>
              )}
            </GridItem>
          </Grid>

          <Grid mt="25px" templateColumns="repeat(4, 1fr) 1fr" gap="25px">
            <GridItem colSpan={{ base: 2, md: 2, lg: 1 }}>
              <Flex>
                <CustomDropzone
                  whiteSpace={true}
                  formProps={{ setFieldValue }}
                  title="Anexar Identidade"
                  fieldName="identidade"
                  height="42px"
                  width={"216px"}
                />
              </Flex>
            </GridItem>
          </Grid>
        </>
      )}
    </Group>
  );
};
